import { c as _c } from "react/compiler-runtime";
import { Typography } from '@/components/Typography';
import { getDrawerFilterIdFromTitle } from '@/components/blocks/cms/FilteredFleetTypeCardsBlock/FilterDrawer';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
interface FilterDrawerTriggerProps {
  title: string;
}
export function FilterDrawerTrigger(t0) {
  const $ = _c(6);
  const {
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = getDrawerFilterIdFromTitle(title);
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const drawerId = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PhosphorIcon className="text-[24px]" name="caret-right" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== drawerId || $[4] !== title) {
    t3 = <Typography as="label" variant="h6" htmlFor={drawerId} className="flex flex-row drawer-button justify-between items-center gap-2">{title}{t2}</Typography>;
    $[3] = drawerId;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}